export interface FileParams {
  id: string;
  subjectId: string;
  subjectType: FileSubjectTypes;
  fileName: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  s3Url: string;
  // Created ahead of its bytes and not yet confirmed in S3. Readers skip these.
  pending?: boolean;
}

export enum FileSubjectTypes {
  CUSTOM_FIELD = 'customField',
  OBJECT_VALUE = 'objectValue',
  COMMANDING_RUN_TASK = 'commandingRunTask',
  COMMANDING_RUN = 'commandingRun',
  ENTERPRISE = 'enterprise',
  EVIDENCE_ITEM = 'evidenceItem',
  FUSA_ORGANIZATION = 'fusaOrganization',
  WORKSPACE = 'workspace',
  PROJECT = 'project',
  SUPPORT_DOCUMENTATION = 'supportDocumentation',
  PRODUCT_PAGE_CONTENT = 'productPageContent',
  /** what was entered on a schema: a report's images and captures */
  RECORD = 'record',
}

export enum FileTypes {
  IMAGE = 'image',
  VIDEO = 'video',
  PDF = 'pdf',
  GENERIC = 'generic',
}

export const PREVIEWABLE_TYPES = [FileTypes.IMAGE, FileTypes.VIDEO, FileTypes.PDF];

export type CreateFileParams = Pick<FileParams, 'subjectId' | 'subjectType' | 'fileName' | 's3Url' | 'pending'>;

